import { LearningCenterManagementService } from './../../learning-center-management.service';
import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import Player from '@vimeo/player';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ELearningManagementService } from 'src/app/modules/e-learning-management/e-learning-management.service';
import { uploadFileNz, uploadFiles } from 'src/app/shared/models/uploadFiles.model';
import { map } from 'rxjs/operators';
import * as tus from 'tus-js-client';
import { Subject, Subscription, of } from 'rxjs';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-learning-center-video-section-uploader',
  templateUrl: './learning-center-video-section-uploader.component.html',
  styleUrls: ['./learning-center-video-section-uploader.component.scss']
})
export class LearningCenterVideoSectionUploaderComponent implements OnInit, AfterViewInit {

  @Input() learningCenterForm: FormGroup;
  @Input() isEdit: boolean


  fileList: NzUploadFile[] = []
  previewVideoId: number;


  constructor(private learningCenterManagementService: LearningCenterManagementService,
    private eLearningService: ELearningManagementService,
    private messageService: NzMessageService,
    private fb: FormBuilder) { }

  ngOnInit(): void {
    if (this.isEdit) {
      this.setVideosFromForm()
    }
  }

  ngAfterViewInit() {

  }

  setVideosFromForm(): void {
    let videosArray = this.learningCenterForm.get('VIDEOS') as FormArray;
    this.fileList = videosArray.controls.map((control, index) => {
      let videoId = control.get('VIDEO_ID').value;
      let file: NzUploadFile = {
        uid: '-' + index, // unique id for the file
        name: `${videoId}.mp4`, // you might want to replace this with the actual file name if it's available
        type: 'video/mp4',
        size: 0, // replace this with actual file size if available
        id: Number(videoId), // id that links the file to the form data
        status: 'done', // since the file is already uploaded
      }
      control.patchValue({ DATA_STATUS: 'original' });
      return file;
    })
  }

  get videoArray(): FormArray {
    return this.learningCenterForm.get('VIDEOS') as FormArray;
  }

  createFormArrayGroup(): FormGroup {
    return this.fb.group({
      VIDEO_ID: [''],
      DATA_STATUS: [''] // Add this
    });
  }

  addVideoGroup(): void {
    (this.learningCenterForm.get('VIDEOS') as FormArray).push(this.createFormArrayGroup());
  }

  getBase64(file: File): Promise<string | ArrayBuffer | null> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  previewImage: string | undefined = '';
  previewVisible = false;

  beforeUpload = (file: NzUploadFile): boolean => {
    // check file type
    const isVideo = file.type === 'video/mp4';
    if (!isVideo) {
      this.messageService.error('รองรับเฉพาะไฟล์วิดีโอ นามสกุล .mp4 เท่านั้น', { nzDuration: 5000 });
      return false;
    }
  }

  handleUpload = ({ file, fileList, onSuccess, onError }: { file: any, fileList: NzUploadFile[], onSuccess: any, onError: any }): Subscription => {
    let exVdoUri
    return this.eLearningService.createVideo(file).pipe(map((response) => {
      const videoFile = new uploadFiles(file, response.body.link, response.body.upload.upload_link);
      exVdoUri = response.body.uri.slice(8);


      return new tus.Upload(file, {
        endpoint: videoFile.uploadURI,
        uploadUrl: videoFile.uploadURI,
        retryDelays: [0, 3000, 5000, 10000, 20000],
        onError: error => {
          return onError(error)
        },
        onProgress: () => {

        },
        onSuccess: () => {
          this.addVideoGroup();
          this.videoArray.at(this.videoArray.length - 1).patchValue({ VIDEO_ID: exVdoUri, DATA_STATUS: 'add' });
          return onSuccess(response, file, fileList)
        }
      }).start()
    })).subscribe(() => {
      this.fileList[this.fileList.length - 1].id = exVdoUri;
    });

  }

  removeFile = (file: NzUploadFile): boolean => {
    const index = this.fileList.indexOf(file);
    const videoIndex = this.videoArray.value.findIndex((video) => video.VIDEO_ID === file.id);
    if (index > -1) {
      this.fileList.splice(index, 1);
    }
    if (videoIndex > -1) {
      const video = this.videoArray.at(videoIndex);
      if (video.get('DATA_STATUS').value === 'original') {
        video.patchValue({ DATA_STATUS: 'remove' });
      } else if (!this.isEdit) {
        this.videoArray.removeAt(videoIndex);
      }
    }
    return true;
  }

  handlePreview = async (file: NzUploadFile): Promise<void> => {
    this.previewVideoId = file.id;
    this.previewVisible = true;
  };
}

